export enum IndexImpactTypes {
    positive = "positive",
    negative = "negative",
}

export enum IndexCurveTypes {
    linear = "linear",
    exponential = "exponential",
}
